import { render, staticRenderFns } from "./ConsultaCorretor.vue?vue&type=template&id=21711b14&"
import script from "./ConsultaCorretor.vue?vue&type=script&lang=js&"
export * from "./ConsultaCorretor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports